import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { cloneDeep } from 'lodash';
import { Subscription } from 'rxjs';
import { ProductConfigOpsType, ProductConfigStep, V6ProductType } from '../../../core/enums';
import { Bp1configurationRequest, Bp2ConfigurationRequest, IBp1configurationRequest, IBp2ConfigurationRequest, IBuildPakAttribute, IFrameTemplate, IGetProductDependencies, ProductTemplate, V6nestedFrame, V6option, V6outerFrameBp1 } from '../../../core/models';
import { CommonService } from '../../../core/services/common.service';
import { ProductService } from '../../../core/services/product.service';
import { UserService } from '../../../core/services/user.service';
import { V6macroService } from '../../../core/services/v6macro.service';
import { V6productService } from '../../../core/services/v6product.service';
import { V6translationService } from '../../../core/services/v6translation.service';

@Component({
  selector: 'app-build-kwikkey-product',
  templateUrl: './build-kwikkey-product.component.html',
  styleUrls: ['./build-kwikkey-product.component.scss']
})
export class BuildKwikkeyProductComponent implements OnInit, OnDestroy {
  //#region  constructor ngOnInit
  public subscription: Subscription;
  createConfigurationRequest: IBp1configurationRequest = new Bp1configurationRequest();
  updateConfigRequest: IBp2ConfigurationRequest = new Bp2ConfigurationRequest();
  pm: ProductTemplate = new ProductTemplate();
  //currentProductConfigStep: ProductConfigStep;
  configCreationInProgres: boolean = false;
  imageLoading: boolean = true;
  thumbnail: any;
  selectedTab: boolean = true;
  productModelLoading: boolean = false;
  productImageLoading: boolean = false;
  apiDuration: number;
  summaryViewOnly: boolean = false;
  productInitializing: boolean = true;
  sourceFrame: IFrameTemplate = null;
  isOnSummaryPage: boolean = false;
  constructor(private productService: ProductService,
    private v6productService: V6productService,
    private v6translationService: V6translationService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private v6MacroService: V6macroService,
    private sanitizer: DomSanitizer,
    private userService: UserService) {
    this.productInitializing = false;
    this.v6productService.currentConfigOPsType = ProductConfigOpsType.ADD;
  }
  get currentProductConfigStep() {
    return this.v6productService.currentProductConfigStep;
  }
  set currentProductConfigStep(cp) {
    this.v6productService.currentProductConfigStep = cp;
  }
  productModel: ProductTemplate = new ProductTemplate();
  get pt() {
    switch (this.currentProductConfigStep) {
      case ProductConfigStep.BASE_CONFIG:
        return this.v6productService.bp1PreviewModel;
        break;
      case ProductConfigStep.CONFIG_DETAILS:
        return this.v6productService.bp2PreviewModel;
        break;
      case ProductConfigStep.CONFIRM_CONFIG:
        return this.v6productService.bp3PreviewModel;
        break;
      default:
        return this.v6productService.bp1PreviewModel;
        break;
    }
  }
  //#region Init
  paintCode: string = '';
  ngOnInit(): void {
    this.subscription = this.route.params.subscribe(params => {
      console.log('The id of this route is: ', params);
      this.v6productService.v6ProductPreview.productCode = params.productCode;
      if (this.v6productService.v6ProductPreview.paintCode) {
        this.paintCode = this.v6productService.v6ProductPreview.paintCode;
        console.log('PaintCode: ', this.v6productService.v6ProductPreview.paintCode);
        console.log('PaintName: ', this.v6productService.v6ProductPreview.paintName);
      }
      this.initProduct();

    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  async initProduct() {
    this.productInitializing = true;
    //get details from db, product details, attribute details, macro details
    const p = this.v6productService.v6ProductPreview;
    let prdM: ProductTemplate = this.v6productService.v6ProductPreview.template;
    let productDependencies: IGetProductDependencies = null;
    if (!p.productCode) { return; }
    this.v6translationService.initData();
    if (p.productCode) {
      //load product template from api
      const response = await this.v6productService.loadKwikkeyProductDetails(p.productCode,'')
      prdM = JSON.parse(response.templateDescription);
      prdM.productCode = p.productCode.toString();
      productDependencies = response.dependencies;
      prdM.translationFamily = response.translationFamily;
      prdM.freightFamily = response.freightFamily;
    }
    else {
      //load only dependencies      
      const productDependenciesResponse = await this.v6productService.loadProductDependencies(p.dependentAttributeIdList, p.dependentMacroIdList)
      productDependencies = cloneDeep(productDependenciesResponse);
    }
    prdM.productAttributes = this.v6productService.switchBuildPakAttributes(prdM.productAttributes, productDependencies.attributes);
    prdM.resourceFrame.attributeFilters = this.v6productService.switchBuildPakAttributes(prdM.resourceFrame.attributeFilters, productDependencies.attributes);
    prdM.nestedFrames.forEach((el, i) => {
      el.attributeFilters = this.v6productService.switchBuildPakAttributes(el.attributeFilters, productDependencies.attributes);
      const crossRailAttr = el.attributeFilters.find(x => x.publishedName === 'Cross Rails');
      if (crossRailAttr) {
        crossRailAttr.value = crossRailAttr.options[0].value;
        crossRailAttr.code = crossRailAttr.options[0].code;
      }
    });
    if (prdM.configNameExpression) {
      prdM.configNameExpression = this.v6productService.switchNameMacro(prdM.configNameExpression.id, productDependencies.macros);
    }
    prdM.bp1Macros = this.v6productService.switchMacros(prdM.bp1Macros, productDependencies.macros);
    prdM.bp2Macros = this.v6productService.switchMacros(prdM.bp2Macros, productDependencies.macros);
    if (prdM.type === V6ProductType.KWIK_KEY_DOOR || prdM.type === V6ProductType.KWIK_KEY_FRAME) {
      this.initKKItem(prdM);
    }
    console.log('product model prepared');
    console.log(prdM);
    this.productModel = cloneDeep(prdM);
    if (prdM.bypassBaseConfig) {
      this.createDefaultConfiguration();
    }
    else {
      this.v6productService.bp1PreviewModel = cloneDeep(prdM);
      this.currentProductConfigStep = ProductConfigStep.BASE_CONFIG;
      this.productInitializing = false;
    }

  }
  createDefaultConfiguration() {
    this.createConfigurationRequest = new Bp1configurationRequest();
    this.createConfigurationRequest.customerCode = this.userService.readUserObject.customerNumber.toString();//get current cust no from user service 
    if (this.productModel.bypassBaseConfig) {
      //fill default value in bp1 request
      this.productModel.reference = '';
      this.createConfigurationRequest.reference = this.productModel.reference;
      this.createConfigurationRequest.quantity = this.productModel.quantity;
      this.createConfigurationRequest.defaultOptions = [];
      this.createConfigurationRequest.outerFrame = new V6outerFrameBp1();
      const jobFin = this.productModel.productAttributes.find(x => x.publishedName === 'Exterior Finish');
      const hardwareFin = this.productModel.productAttributes.find(x => x.publishedName === 'Hardware Finish');
      if (jobFin) {
        jobFin.value = jobFin.options[0].value;
        jobFin.code = jobFin.options[0].code;
      }
      this.createConfigurationRequest.defaultOptions.push({ code: "Job/Exterior Finish", value: '[COL: K: 14(14)]' });
      //this.createConfigurationRequest.defaultOptions.push({ code: "Job/Exterior Finish", value: '[COL: K: 14(14)]' });
      this.v6productService.buildResourceFrameCode(this.productModel.resourceFrame);
      this.createConfigurationRequest.outerFrame.frameCode = this.productModel.resourceFrame.frameConfig;
      this.createConfigurationRequest.originalDescription = this.productModel.productName;
      console.log('deafult config request');
      console.log(this.createConfigurationRequest);

      ////////////only for test reg start
      //////////this.v6productService.bp1PreviewModel = cloneDeep(this.productModel);//test
      //////////const resp = STD_DR_2DO;//test
      //////////this.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
      //////////let destination = this.productModel;
      //////////this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
      //////////this.v6MacroService.runMacros('pageLoad', this.productModel.bp2Macros, this.productModel);

      //////////this.productModel.resourceFrame.attributeFiltersForUI = this.v6productService.organizeControlsInTabluarForm(this.productModel.resourceFrame.attributeFilters);
      //////////this.productModel.nestedFrames.forEach((el, index) => {
      //////////  el.attributeFiltersForUI = this.v6productService.organizeControlsBySection(el.attributeFilters);
      //////////})

      //////////this.productModelLoading = false;
      //////////this.imageLoading = true;
      //////////this.productImageLoading = true;
      //////////this.productInitializing = false;
      //////////return;
      //////////////only for test reg end
      const start = new Date().getTime()
      this.v6productService.createConfigurationX(this.createConfigurationRequest).subscribe(resp => {
        this.configCreationInProgres = false;
        if (resp) {
          //const resp = this.up2();//test          
          this.v6productService.bp2PreviewModel = cloneDeep(this.productModel);
          let destination = this.v6productService.bp2PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          ////////const end = new Date().getTime();
          ////////this.apiDuration = (end - start) / 1000;
          ////this.productInitializing = false;
          this.getProductImage(this.v6productService.bp2PreviewModel.quoteItemCommonId);
          this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
          this.productInitializing = false;
        }
        else {
          //something happend
        }
      });
    }
  }

  getProductImage(quoteItemCommonId: string) {
    this.imageLoading = true;
    this.productImageLoading = true;
    const data = {
      quoteItemCommonId: quoteItemCommonId,
      width: 150,
      height: 150,
    }
    this.productService.getThumbnailImage(data).subscribe(resp => {
      this.imageLoading = false;
      //this.createConfiguration = resp;
      let objectURL = 'data:image/jpeg;base64,' + resp;
      this.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.productImageLoading = false;
    })
  }
  initKKItem(prdM: ProductTemplate) {
    if (prdM.type === V6ProductType.KWIK_KEY_DOOR) {
      const ppFin = prdM.productAttributes.find(x => x.v6ReferenceCode === 'PushPull Finish');
      const eFin = prdM.productAttributes.find(x => x.v6ReferenceCode === 'Job/Exterior Finish');
      const crl = prdM.productAttributes.find(x => x.publishedName === 'Cross Rails');
      if (ppFin) {
        ppFin.show = false;
        ppFin.value = null;
      }
      if (eFin) {
        eFin.show = false;
        if (this.paintCode) {
          eFin.value = "[COL:K:" + this.paintCode + " (22)]";//[COL:K:789G035 (22)]
          prdM.kwikKeyV6Finish = eFin.value;
        }
      }
      if (crl) {
        crl.value = crl.options[0].value;
      }
      const transomAttr = prdM.resourceFrame.attributeFilters.find(x => x.name === 'Transom');
      if (transomAttr) {
        transomAttr.value = 'Non-Transom';
        transomAttr.isDirty = true;
      }
    }
    else {
      const ppFin = prdM.productAttributes.find(x => x.v6ReferenceCode === 'PushPull Finish');
      const eFin = prdM.productAttributes.find(x => x.v6ReferenceCode === 'Job/Exterior Finish');
      const crl = prdM.resourceFrame.attributeFilters.find(x => x.publishedName === 'Cross Rails');
      if (ppFin) {
        ppFin.show = false;
        ppFin.value = null;
      }
      if (eFin) {
        eFin.show = false;
        if (this.paintCode) {
          eFin.value = "[COL:K:" + this.paintCode + " (22)]";//[COL:K:789G035 (22)]
          prdM.kwikKeyV6Finish = eFin.value;
        }
      }
      if (crl) {
        crl.value = crl.options[0].value;
      }
      const transomAttr = prdM.productAttributes.find(x => x.name === 'Transom');
      if (transomAttr) {
        if (prdM.kwikKeyOptionCode.endsWith('TR')) {
          transomAttr.value = 'Transom';
          let ntr = transomAttr.options.find(x => x.value === 'Non-Transom');
          if (ntr) { ntr.show = false; }
        }
        else {
          transomAttr.value = 'Non-Transom';
          let tr = transomAttr.options.find(x => x.value === 'Transom');
          if (tr) { tr.show = false; }
        }

      }
    }
  }




  responseReceiveBP1(quoteItemCommonId) {
    console.log('bp1-->' + quoteItemCommonId);
    this.getProductImage(quoteItemCommonId);
  }
  responseReceiveBP2(quoteItemCommonId) {
    console.log('bp2-->' + quoteItemCommonId);
    this.getProductImage(quoteItemCommonId);
  }


}
